<template>
  <div>
    <span class="navigation-title"> Dados básicos </span>
    <v-form ref="form">
      <v-row class="ma-0 mr-5 mt-8" dense>
        <v-col class="py-0" cols="12" sm="4">
          <span class="label-bold">E-mail</span>
          <v-text-field
            dense
            class="primary-input"
            outlined
            placeholder="example@mail.com"
            :rules="[
              (v) => !!v || 'Insira seu e-mail',
              (v) => /.+@.+\..+/.test(v) || 'E-mail inválido',
            ]"
            v-model="user.nm_email"
          ></v-text-field>
        </v-col>

        <v-col class="py-0" cols="12" sm="4">
          <span class="label-bold">Nome</span>
          <v-text-field
            dense
            class="primary-input"
            outlined
            placeholder="Seu nome"
            v-model="user.nm_pessoa"
          ></v-text-field>
        </v-col>

        <v-col class="py-0" cols="12" sm="4">
          <span class="label-bold">CPF</span>
          <v-text-field
            dense
            class="primary-input"
            outlined
            disabled
            placeholder="CPF completo"
            v-model="user.nr_cpf_cnpj"
          ></v-text-field>
        </v-col>

        <v-col class="py-0" cols="12" sm="7">
          <span class="label-bold">CEP</span>
          <v-text-field
            dense
            class="primary-input"
            @keyup="searchCep"
            :loading="cepLoading"
            outlined
            v-mask="['#####-###']"
            append-icon="mdi-map-marker"
            placeholder="000000-000"
            :rules="[(v) => !!v || 'Insira seu CEP']"
            v-model="user.nm_cep"
          ></v-text-field>
        </v-col>

        <v-col class="py-0" cols="12" sm="5">
          <span class="label-bold">Endereço</span>
          <v-text-field
            dense
            class="primary-input"
            outlined
            placeholder="Digite seu endereço"
            :rules="[(v) => !!v || 'Insira seu endereço']"
            v-model="user.nm_endereco"
          ></v-text-field>
        </v-col>

        <v-col class="py-0" cols="12" sm="5">
          <span class="label-bold">Bairro</span>
          <v-text-field
            dense
            class="primary-input"
            outlined
            placeholder="Digite seu bairro"
            :rules="[(v) => !!v || 'Insira seu bairro']"
            v-model="user.nm_bairro"
          ></v-text-field>
        </v-col>

        <v-col class="py-0" cols="12" sm="5">
          <span class="label-bold">Cidade</span>
          <v-text-field
            dense
            class="primary-input"
            outlined
            placeholder="Digite seu cidade"
            :rules="[(v) => !!v || 'Insira seu cidade']"
            v-model="user.nm_cidade"
          ></v-text-field>
        </v-col>

        <v-col class="py-0" cols="6" sm="2">
          <span class="label-bold">Número</span>
          <v-text-field
            dense
            type="number"
            class="primary-input"
            outlined
            placeholder="0000"
            :rules="[(v) => !!v || 'Insira seu DDD']"
            v-model="user.nr_endereco"
          ></v-text-field>
        </v-col>

        <v-col class="py-0" cols="6" sm="1">
          <span class="label-bold">Estado</span>
          <v-text-field
            dense
            class="primary-input"
            outlined
            placeholder="UF"
            :rules="[(v) => !!v || 'Insira seu telefone']"
            v-model="user.nm_uf"
          ></v-text-field>
        </v-col>

        <v-col class="py-0" cols="6" sm="1">
          <span class="label-bold">DDD</span>
          <v-text-field
            dense
            v-mask="['##']"
            class="primary-input"
            outlined
            placeholder="000"
            :rules="[(v) => !!v || 'Insira seu número']"
            v-model="user.nr_ddd"
          ></v-text-field>
        </v-col>

        <v-col class="py-0" cols="6" sm="3">
          <span class="label-bold">Telefone</span>
          <v-text-field
            dense
            class="primary-input"
            outlined
            v-mask="['#####-####']"
            placeholder="00000-0000"
            :rules="[(v) => !!v || 'Insira seu estado']"
            v-model="user.nr_telefone"
          ></v-text-field>
        </v-col>
        <v-col class="py-0" cols="6" sm="7">
          <span class="label-bold">Complemento</span>
          <v-text-field
            dense
            class="primary-input"
            outlined
            placeholder="Digite seu complemento"
            :rules="[(v) => !!v || 'Insira seu complemento']"
            v-model="user.nm_complemento"
          ></v-text-field>
        </v-col>

        <v-col cols="12" class="d-flex justify-end">
          <v-btn
            :style="
              $vuetify.theme.primary
                ? `color: var(--custom-white-second-color) !important; background-color: ${$vuetify.theme.primary} !important;`
                : 'color: var(--custom-white-second-color) !important;'
            "
            class="primary-button"
            :loading="loading"
            @click="submit"
          >
            Prosseguir
            <v-icon class="ml-2">mdi-arrow-right-bold-circle-outline</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<style scoped>
.label-bold {
  white-space: nowrap !important;
}
</style>

<script>
import GeneralService from "../../../../services/GeneralServices";
import ApiService from "../../../../services/ApiService";

export default {
  name: "personal",

  props: {
    user_prop: Object,
  },

  data() {
    return {
      modal: false,
      insuredExists: false,
      loading: false,
      api: new ApiService(),
      cepLoading: false,
      user: {},
      generalService: new GeneralService(),
      generalOptions: ["Sim", "Não"],
      cpfRules: [
        (v) => !!v || "Insira seu CPF completo",
        (v) => this.generalService.validateCPF(v) || "CPF inválido",
      ],
    };
  },

  created() {
    this.getInsured();
    console.log("user", this.user_prop);
  },
  methods: {
    searchCep() {
      if (this.user.nm_cep?.length < 9) {
        return;
      }

      this.cepLoading = true;

      this.api
        .get(`cep?number=${this.user.nm_cep?.replace("-", "")}`)
        .then((res) => {
          this.user.nm_endereco = res.logradouro;
          this.user.nm_bairro = res.bairro;
          this.user.nm_cidade = res.localidade;
          this.user.nm_uf = res.uf;

          this.cepLoading = false;
        })
        .catch(() => {
          localStorage.setItem("apiErrorDescription", "Erro ao buscar o CEP!");
          this.cepLoading = false;
        });
    },
    async getInsured() {
      this.loading = true;
      await this.api
        .post(`get-insured`, {
          cpf: this.user_prop.nr_cpf_cnpj?.replace(/\D/g, ""),
          token: localStorage.getItem("token"),
        })
        .then((response) => {
          // console.log('response', response);
          if (!response.id_pessoa) {
            this.user = { ...this.user_prop };
            this.insuredExists = false;
            this.loading = false;
          } else {
            this.insuredExists = true;
            this.user = { ...response };
            localStorage.setItem("user", JSON.stringify(this.user));
          }
          this.loading = false;
        })
        .catch(() => {
          localStorage.setItem(
            "apiErrorDescription",
            "Erro ao salvar as infos pessoais!"
          );
          this.user = { ...this.user_prop };
          this.insuredExists = false;
          this.loading = false;
        });
      this.loading = false;
    },

    async submit() {
      if (this.$refs.form.validate()) {
        // if (!this.insuredExists) {
        this.loading = true;
        this.user = {
          nr_cpf_cnpj: this.user.nr_cpf_cnpj.replace(/\D/g, ""),
          nm_pessoa: this.user.nm_pessoa,
          cd_papel: "2",
          cd_tipo_pessoa: this.user.cd_tipo_pessoa,
          id_tp_endereco: "2",
          nm_endereco: this.user.nm_endereco,
          nr_endereco: this.user.nr_endereco,
          nm_bairro: this.user.nm_bairro,
          nm_cidade: this.user.nm_cidade,
          nm_uf: this.user.nm_uf,
          nm_cep: this.user.nm_cep.replace("-", ""),
          cd_tp_meio_comunicacao: "3",
          dv_principal: "True",
          nm_email: this.user.nm_email,
          dv_principal_fatura: "True",
          nr_telefone: this.user.nr_telefone.replace(/\D/g, ""),
          nr_ddd: this.user.nr_ddd.replace(/\D/g, ""),
          nm_complemento: this.user.nm_complemento,
        };

        await this.generalService.saveSessionInfo({
          name: this.user.nm_pessoa,
          email: this.user.nm_email,
          cpf: this.user.nr_cpf_cnpj,
          phone: `${this.user.nr_ddd} ${this.user.nr_telefone}`
        });

        localStorage.setItem("user", JSON.stringify(this.user));
        await this.api
          .post("create-insured", {
            token: localStorage.getItem("token"),
            insured: this.user,
          })
          .then((response) => {
            if (response.cd_retorno == "0") {
              this.$toast.success("Segurado cadastrado com sucesso!");
              this.insuredExists = true;
              this.user.id_pessoa = response.id_pessoa;
              localStorage.setItem("user", JSON.stringify(this.user));
              this.loading = false;
              this.$emit("next", 1);
            } else {
              this.$toast.error(
                response.nm_retorno || "Ocorreu um erro na comunicacao!"
              );
              this.loading = false;
            }
          })
          .catch(() => {
            localStorage.setItem(
              "apiErrorDescription",
              "Erro ao cadastrar segurado!"
            );
            this.loading = false;
          });
        this.loading = false;
      }
    },
  },
};
</script>
